import React from 'react';
import { AtSignIcon, MailIcon } from 'lucide-react';
import { INSTAGRAM_HANDLE, INSTAGRAM_LINK, SUPPORT_EMAIL } from './Shared';
import { Coin } from './Decor';
export function Footer() {
  return <>
      {/* P.D. */}
      <section className="border-t-2 border-brand-gold bg-brand-sand py-14" aria-labelledby="pd-title" data-id="element-129" data-mp="32p5mwh8vcypb">
        <div className="mx-auto max-w-3xl px-4 sm:px-6 lg:px-8" data-id="element-130" data-mp="36q900vzj8gmu">
          <h2 id="pd-title" className="font-title text-xl text-brand-jadeDeep md:text-2xl" data-id="element-131" data-mp="3ueiltxwqx4dz">
            P.D.: Si tenés dudas, escribinos.
          </h2>
          <div className="hair-rule mt-4 max-w-[10rem]" aria-hidden="true" data-id="element-132" data-mp="37xv6falryhh" />
          <ul className="mt-5 space-y-3 text-sm text-brand-inkLight md:text-base" data-id="element-133" data-mp="3ldkdx4j6scq4">
            <li className="flex items-center gap-3" data-id="element-134" data-mp="3qcdtd2i1adsx">
              <MailIcon className="h-4 w-4 shrink-0 text-brand-jade" aria-hidden="true" data-id="element-135" data-mp="3qf9s2t1ph6if" />
              <span data-id="element-136" data-mp="2a19qldn7p8t2">
                <strong className="text-brand-ink" data-id="element-137" data-mp="2ey0907mhoghn">Email:</strong>{' '}
                <a href={`mailto:${SUPPORT_EMAIL}`} className="font-semibold text-brand-cinnabar underline-offset-4 transition-colors duration-150 ease-out hover:text-brand-cinnabarDark hover:underline" data-id="element-138" data-mp="2ew6yuico3e4w">
                  {SUPPORT_EMAIL}
                </a>
              </span>
            </li>
            <li className="flex items-center gap-3" data-id="element-139" data-mp="3v916dfu99b2e">
              <AtSignIcon className="h-4 w-4 shrink-0 text-brand-jade" aria-hidden="true" data-id="element-140" data-mp="3q8dj9595dedg" />
              <span data-id="element-141" data-mp="82icbryzq8eb">
                <strong className="text-brand-ink" data-id="element-142" data-mp="81yyamcgo45k">Instagram:</strong>{' '}
                <a href={INSTAGRAM_LINK} className="font-semibold text-brand-cinnabar underline-offset-4 transition-colors duration-150 ease-out hover:text-brand-cinnabarDark hover:underline" data-id="element-143" data-mp="34gyblgf8z9p">
                  {INSTAGRAM_HANDLE}
                </a>
              </span>
            </li>
          </ul>
          <p className="mt-5 font-serif text-sm italic text-brand-muted md:text-base" data-id="element-144" data-mp="qt05fxnqj607">
            Nuestro equipo puede ayudarte con cualquier consulta sobre tu compra o acceso.
          </p>
        </div>
      </section>

      {/* Footer */}
      <footer className="relative overflow-hidden bg-brand-jadeDeep py-14 text-center text-brand-rice" data-id="element-145" data-mp="two07ivoux21">
        <div className="lattice absolute inset-0 opacity-[0.06]" aria-hidden="true" data-id="element-146" data-mp="yuh6ebwzrr2b" />
        <div className="relative mx-auto max-w-4xl px-4 sm:px-6 lg:px-8" data-id="element-147" data-mp="13rpsgnl9gf8u">
          <Coin className="mx-auto h-8 w-8 text-brand-goldLight/70" data-id="element-148" data-mp="18k97zq3idkga" />
          <p className="mt-4 font-title text-xl uppercase tracking-[0.3em] text-brand-goldLight md:text-2xl" data-id="element-149" data-mp="1clm95mvnozgv">
            Vision Digital
          </p>
          <p className="mt-3 font-serif text-base text-brand-rice/80 md:text-lg" data-id="element-150" data-mp="1hj4aos7cgceu">
            Herramientas digitales para aprender, aplicar y transformar.
          </p>

          <div className="mt-7 flex flex-col items-center justify-center gap-3 text-sm md:flex-row md:gap-8" data-id="element-151" data-mp="1rj4xio4f9ans">
            <a href={`mailto:${SUPPORT_EMAIL}`} className="text-brand-rice/75 transition-colors duration-150 ease-out hover:text-brand-goldLight" data-id="element-152" data-mp="3oc6q8vsmgvyg">
              {SUPPORT_EMAIL}
            </a>
            <a href={INSTAGRAM_LINK} className="text-brand-rice/75 transition-colors duration-150 ease-out hover:text-brand-goldLight" data-id="element-153" data-mp="2afdm9nra1su2">
              {INSTAGRAM_HANDLE}
            </a>
          </div>

          <div className="mt-10 space-y-2 border-t border-white/15 pt-6 text-xs text-brand-rice/55" data-id="element-154" data-mp="21nv4j8eon4yv">
            <p data-id="element-155" data-mp="1worz3musiwqd">© Vision Digital 2026 — Todos los derechos reservados.</p>
            <p data-id="element-156" data-mp="2tdpt32upuqmh">Prohibida la reproducción y redistribución sin autorización expresa.</p>
            <p data-id="element-157" data-mp="2pcebnklzxbpd">Ley 25.326 — Protección de Datos Personales — República Argentina</p>
            <p data-id="element-158" data-mp="2pajqc56tbhkr">Ley 11.723 — Propiedad Intelectual — República Argentina</p>
          </div>

          <p className="mx-auto mt-6 max-w-2xl text-[11px] leading-relaxed text-brand-rice/45" data-id="element-159" data-mp="2kfe75e4soh0d">
            Aviso: FENG SHUI NEGOCIOS™ es material educativo. Combina principios asociados a distintas corrientes del
            Feng Shui con recomendaciones contemporáneas de organización, mantenimiento y percepción del espacio. No
            garantiza ventas, clientes, pacientes, prosperidad ni resultados económicos específicos.
          </p>
        </div>
      </footer>
    </>;
}